import React, { createContext, useMemo } from 'react';
import { isEmpty, cond, constant } from 'lodash';
import { maybe } from 'site-modules/shared/utils/incentives/gql-incentives-filter';
import { getPotentialRebatesSum } from 'site-modules/shared/components/incentives/incentives-wizard/utils/get-potential-rebates-sum';
import { buildEligibleIncentives } from 'site-modules/shared/components/incentives/incentives-wizard/utils/build-eligible-incentives';

export const getButtonText = (hasSaveResults, totalRebates, incentives) => {
  const buttonText = cond([
    [() => hasSaveResults, constant('See Rebates')],
    [() => incentives?.length && !isNaN(totalRebates), constant('See Your Offers')],
    [() => !incentives?.length && !isNaN(totalRebates), constant('Search for Rebates')],
  ])();

  return buttonText || '';
};

export const SrpTopIncentivesContext = createContext({ totalRebates: undefined, buttonText: '', href: undefined });
export const SrpTopIncentivesContextProvider = ({ children, wizardState, incentives }) => {
  const hasSaveResults = !isEmpty(wizardState);

  const eligibleIncentives = !hasSaveResults
    ? incentives
    : buildEligibleIncentives(incentives, wizardState.eligibleIncentiveIds);
  const totalRebates = maybe(eligibleIncentives).map(getPotentialRebatesSum).unpack();
  const buttonText = getButtonText(hasSaveResults, totalRebates, incentives);

  const providerValue = useMemo(
    () => ({
      totalRebates,
      buttonText,
      href: buttonText === 'Search for Rebates' ? '/electric-car/tax-credits-rebates-incentives' : undefined,
    }),
    [buttonText, totalRebates]
  );

  return <SrpTopIncentivesContext.Provider value={providerValue}>{children}</SrpTopIncentivesContext.Provider>;
};
